import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { HowItWorks } from './components/HowItWorks';
import { Features } from './components/Features';
import { Testimonials } from './components/Testimonials';
import { CallToAction } from './components/CallToAction';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream overflow-x-hidden" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <HowItWorks data-id="element-4" />
        <Features data-id="element-5" />
        <Testimonials data-id="element-6" />
        <CallToAction data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}